import axios from "axios";
import { environment } from "../environment";

export class IpAddressResolverService {
  async resolveClientIpAddress(): Promise<string> {
    let response = await axios.get(environment.ipAddressResolverUrl as string, {
      timeout: 2000,
    });
    return response.data.ip;
  }
}
